<template>
    <div style="margin:0 -12px;">
        <div class="luna-header-box">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-6">
                        <br />
                        <a href="/card" class="link" @click="confirmSave()" style="text-decoration:none;">
                            <i class="bi bi-chevron-left"></i>
                        </a>
                    </div>
                    <div class="col-6 text-end">
                        <br />
                        <a :href="'/card/mod/' + card.id"
                            v-if="card && (btn_type == CARD_REGISTRATION_STATE.OWNER_REGISTERED || btn_type == CARD_REGISTRATION_STATE.OWNER_REGISTERABLE)"
                            style="color:#cdcdcd;text-decoration:none;" @click="confirmSave()">編集</a>
                        <a v-else-if="card" style="color:#cdcdcd;text-decoration:none;" @click="setPenalty(4, card.id)">通報する</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="wrap" v-if="card">
            <div class="container-fluid" style="padding-top:70px;">
                <br>
                <div class="row">
                    <div class="col-5">
                        <img :src="card.thumbnail_image" class="rounded img-fluid">
                    </div>
                    <div class="col">
                        <table style="height: 100%;width:100%;">
                            <tbody>
                                <tr>
                                    <td class="align-top" colspan="2">
                                        <h5>{{ card.name }}</h5>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="align-bottom">
                                        <div style="color:#999">{{ card.category_name }}</div>
                                    </td>
                                    <td class="align-bottom text-end">
                                        <button type="button" class="btn btn-luna-d"
                                            style="color:#6b4eff;font-size: 12px; padding: 8px 12px;background:#f2f2f2;border:0;"
                                            :onclick="`window.open('${tweet}&hashtags=LunaSM')`">
                                            <TwitterXIcon /> 共有
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <br>
                <div class="row">
                    <div class="col px-0">
                        <ul class="nav nav-pills nav-justified">
                            <li class="nav-item">
                                <a class="luna-nav-link" id="tab1"
                                    v-bind:class="[tab == 1 ? 'luna-card-active' : 'luna-card-non-active']"
                                    @click="tab = 1">コメント</a>
                            </li>
                            <li class="nav-item">
                                <a class="luna-nav-link" id="tab2"
                                    v-bind:class="[tab == 2 ? 'luna-card-active' : 'luna-card-non-active']"
                                    @click="tab = 2">
                                    <img src="/images/lock.png" width="15"
                                        v-if="user.is_limited && btn_type != CARD_REGISTRATION_STATE.OWNER_REGISTERED && btn_type != CARD_REGISTRATION_STATE.OWNER_REGISTERABLE">
                                    登録中のメンバー</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <br>
                <div v-if="tab == 1">
                    <div class="row"
                        v-if="btn_type != CARD_REGISTRATION_STATE.MEMBER_REGISTERABLE && btn_type != CARD_REGISTRATION_STATE.OWNER_REGISTERABLE">
                        <div class="col">
                            <textarea class="luna-form-control" rows="5" placeholder="ここからコメントができます！"
                                v-model="message"></textarea>
                        </div>
                    </div>
                    <div class="row"
                        v-if="btn_type != CARD_REGISTRATION_STATE.MEMBER_REGISTERABLE && btn_type != CARD_REGISTRATION_STATE.OWNER_REGISTERABLE">
                        <div class="col text-end" style="padding-top:8px;">
                            <button v-if="message != ''" type="button" class="btn btn-luna"
                                style="padding: 2px 14px 5px 16px;" @click="setMessage()">
                                <svg style="height:16px;width:16px;fill:#fff;">
                                    <use xlink:href="/images/icon/dm_send.svg#dm_send"></use>
                                </svg>
                            </button>
                            <button v-else type="button" class="btn btn-luna-d" style="padding: 2px 14px 5px 16px;">
                                <svg style="height:16px;width:16px;fill:#fff;">
                                    <use xlink:href="/images/icon/dm_send.svg#dm_send"></use>
                                </svg>
                            </button>
                        </div>
                    </div>
                    <br>
                    <br>
                    <div v-for="(user_msg, index) in user_list" :key="user_msg.id">
                        <div class="row">
                            <div class="col-2">
                                <a @click="nextShowUser(user_msg.uid)">
                                    <img :src="user_msg.icon_url" class="img-fluid" style="border-radius:100px;">
                                </a>
                            </div>
                            <div class="col">
                                <div class="row">
                                    <div class="col">
                                        <h5>{{ user_msg.name }}&nbsp;<span style="font-size:13px;color:#999;">[{{
                                            user_msg.created_at |
                                                loginStatus }}]</span></h5>
                                    </div>
                                    <div class="col-2 text-end">
                                        <div class="dropdown">
                                            <i class="bi bi-three-dots" style="color:#cdcdcd"></i>
                                            <div class="dropdown-content">
                                                <div class="text-center">
                                                    <a @click="setPenalty(5, user_msg.id)" style="color:#999"
                                                        v-if="user_msg.uid != user.id">通報</a>
                                                    <a @click="rmMessage(user_msg.id)" style="color:#999" v-else>削除</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col" @click="linkDetail(user_msg.id)" style="white-space: pre-line;">{{
                                        user_msg.message }}</div>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <div style="display:flex; padding:5px;flex-wrap: wrap;">
                                            <button v-for="(emoji, e_index) in user_msg.emojis" :key="emoji.id"
                                                type="button" class="btn btn-luna-icon" style="padding:0 8px;"
                                                @click="addEmoji(emoji.emoji, emoji.id, emoji.card_message_id, emoji.card_id, index, e_index)">
                                                <div style="white-space: nowrap">{{ emoji.emoji }}<span
                                                        style="padding-left:2px;font-size:12px;color:#666">{{
                                                            emoji.count
                                                        }}</span></div>
                                            </button>
                                            <div style="">
                                                <div :ref="'tooltipEmojiRef' + user_msg.id"
                                                    class="emoji_picker picker_box">
                                                    <div class="picker_container"
                                                        :ref="'tooltipEmojiPickerRef' + user_msg.id">
                                                        <div class="category" v-for="category in categories"
                                                            :key="`category_${category}`">
                                                            <span>{{ category }}</span>
                                                            <div class="emojis_container">
                                                                <button
                                                                    @click="handleEmojiClick($event, emoji, index, category, user_msg.id)"
                                                                    v-for="(emoji, index) in category_emojis(category)"
                                                                    :key="`emoji_${index}`">
                                                                    {{ emoji }}
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <button
                                                    @click="cmid = user_msg.cmid, message_index = index, tooltipEmojis(user_msg.id, 'tooltipEmojiRef' + user_msg.id, 'tooltipEmojiPickerRef' + user_msg.id)"
                                                    type="button" class="btn btn-luna-icon" style="padding:0 8px;">
                                                    <img src="/images/emoji_add.svg" alt="icon"
                                                        style="width:16px;height:16px;margin-top:-2px;" />
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-3 px-0 text-end">
                                        <div style="padding-right:5px;">
                                            <button type="button" class="btn btn-luna-d"
                                                style="color:#6b4eff;font-size: 12px; padding: 8px 12px;background:#f2f2f2;border:0;"
                                                @click="linkDetail(user_msg.id)">
                                                <svg style="height:12px;width:12px;fill:#6b4eff;margin-top: -3px;">
                                                    <use xlink:href="/images/icon/dm_send.svg#dm_send"></use>
                                                </svg>&nbsp;返信
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col px-0">
                                <hr>
                            </div>
                        </div>
                    </div>
                    <div class="row" v-if="count != 0">
                        <div class="col">
                            <div class="text-center" style="padding-top: 40px; padding-bottom: 20px; color: #6c7072"
                                v-if="is_page && count != 0">
                                <a @click="getMessageMore()">もっとみる</a>
                            </div>
                        </div>
                    </div>
                    <div class="row" v-if="is_load_under">
                        <div class="col text-center">
                            <div class="spinner-grow" role="status">
                                <span class="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div class="row">
                            <div class="col-2">
                                <img src="/images/bord_user.png" class="img-fluid">
                            </div>
                            <div class="col">
                                <div class="row">
                                    <div class="col">
                                        <h5>Luna&nbsp;<span style="font-size:13px;color:#999;">[{{
                                            card.created_at |
                                                loginStatus }}]</span></h5>
                                    </div>
                                    <div class="col-2 text-end">
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        あなたもさっそく投稿してみましょう！
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col px-0">
                                <hr>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-2">
                                <img src="/images/bord_user.png" class="img-fluid">
                            </div>
                            <div class="col">
                                <div class="row">
                                    <div class="col">
                                        <h5>Luna&nbsp;<span style="font-size:13px;color:#999;">[{{
                                            card.created_at |
                                                loginStatus }}]</span></h5>
                                    </div>
                                    <div class="col-2 text-end">
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        書き込む内容は、例えばカードに関するつぶやきや知識・情報交換など、カードに沿った内容ならなんでも書き込めます<br><br>
                                        Luna利用規約に反するカードや内容は発見次第削除します またそれらに関する通報も可能です
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col px-0">
                                <hr>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-2">
                                <img src="/images/bord_user.png" class="img-fluid">
                            </div>
                            <div class="col">
                                <div class="row">
                                    <div class="col">
                                        <h5>Luna&nbsp;<span style="font-size:13px;color:#999;">[{{
                                            card.created_at |
                                                loginStatus }}]</span></h5>
                                    </div>
                                    <div class="col-2 text-end">
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        好みのカードへようこそ！案内人のLunaです<br><br>
                                        ここはコメント欄です。上の「ここからコメントができます！」枠に内容を記入して送信ボタンを押すとコメント欄に投稿できます♪
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col px-0">
                                <hr>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else-if="user.is_limited && btn_type != CARD_REGISTRATION_STATE.OWNER_REGISTERED && btn_type != CARD_REGISTRATION_STATE.OWNER_REGISTERABLE">
                    <div class="row">
                        <div class="col text-center">
                            <div style="padding:20px 0;color:#9990ff;">
                                こちらは有料会員限定の機能です
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col text-center" style="z-index:999">
                            <a href="/plan" @click="confirmSave()">
                                <img src="/images/Group12957.png" style="width:100%;" />
                            </a>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col text-center" style="margin-top:-150px;">
                            <img src="/images/Group13139.png" style="width:100%;" />
                        </div>
                    </div>
                </div>
                <div v-else>
                    <div class="row" v-if="member_count != 0">
                        <div v-for="{ user } in members" :key="user.id" class="col-6">
                            <div>
                                <div style="padding: 10px" @click="nextShowUser(user.id)">
                                    <div class="text-center" style="padding-bottom: 3px">
                                        <img :src="user.icon_url" class="rounded-circle" style="width: 85%" />
                                    </div>
                                    <div style="padding: 5px; font-size: 12px; font-weight: bold" v-if="user.age_view">
                                        {{ area_list[user.area] }}
                                        {{ user.age }}
                                        {{ sex_list[user.sex] }}
                                        <img src="/images/Group12769.png" style="width:18px;"
                                            v-if="user.can_use_all_features" />
                                        <img src="/images/Group12901.png" style="width:18px;"
                                            v-if="user.is_ambassador" />
                                    </div>
                                    <div style="padding: 5px; font-size: 12px; font-weight: bold" v-else>
                                        {{ area_list[user.area] }}
                                        秘密
                                        {{ sex_list[user.sex] }}
                                        <img src="/images/Group12769.png" style="width:18px;"
                                            v-if="user.can_use_all_features" />
                                        <img src="/images/Group12901.png" style="width:18px;"
                                            v-if="user.is_ambassador" />
                                    </div>
                                    <div style="padding: 0 5px; font-size: 12px">
                                        {{ user.last_login_at | lastLoginStatus }}
                                    </div>
                                    <div style="padding: 5px; font-size: 12px">
                                        {{ user.profile | omittedText }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row" v-if="member_count != 0">
                        <div class="col">
                            <div class="text-center" style="padding-top: 40px; padding-bottom: 20px; color: #6c7072"
                                v-if="is_member_page && member_count != 0">
                                <a @click="fetchMemberMore()">もっとみる</a>
                            </div>
                        </div>
                    </div>
                    <div class="row" v-if="is_member_load_under">
                        <div class="col text-center">
                            <div class="spinner-grow" role="status">
                                <span class="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    </div>
                </div>
                <br>
                <br>
                <br>
                <br>
            </div>
        </div>
        <div class="container-fluid luna-footer-card-menu" v-if="card">
            <div class="row">
                <div class="col">
                    <div class="d-grid gap-2" style="padding: 0 5px;">
                        <div v-if="btn_type == CARD_REGISTRATION_STATE.OWNER_REGISTERED" class="text-center"
                            style="font-size:12px;color:#6b4eff;background:#f2f2ff;padding:6px 0;border-radius:6px;">
                            あなたが作ったカードです
                        </div>
                        <button type="button" class="btn btn-luna"
                            style="padding:13px 0;border:0;font-size:16px;"
                            v-if="btn_type == CARD_REGISTRATION_STATE.MEMBER_REGISTERABLE"
                            @click="regCardMember()">
                            好みのカードに登録
                        </button>
                        <button type="button" class="btn btn-luna"
                            style="padding:13px 0;border:0;font-size:16px;background:#c6c4ff;color:#6b4eff;"
                            v-else-if="btn_type == CARD_REGISTRATION_STATE.MEMBER_REGISTERED || btn_type == CARD_REGISTRATION_STATE.OWNER_REGISTERED"
                            @click="rmCardMember()">
                            <img src="/images/card_icon.svg" alt="icon"
                                style="width:16px;height:16px;" />&nbsp;&nbsp;登録済み・タップで解除
                        </button>
                        <button type="button" class="btn btn-luna"
                            style="padding:13px 0;border:0;font-size:16px;"
                            v-else-if="btn_type == CARD_REGISTRATION_STATE.OWNER_REGISTERABLE" @click="regCardMember()">
                            作成したカードを再登録
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import EmojiData from '../../.././json/emojis-data.json';
import { CARD_REGISTRATION_STATE } from '../../constants/cardRegistrationState';
import { clearPageStorage } from '../../event-log/clearPageStorage';

export default {
    data() {
        return {
            count: 0,
            user: [],
            card: null,
            tab: 1,
            message: "",
            user_list: [],
            members: [],
            btn_type: 0,
            is_load: true,
            is_load_under: false,
            is_page: true,
            emojis: [],
            cmid: "",
            message_index: 0,
            emoji_index: 0,
            page: 1,
            windowSize: 0,
            showTooltip: false,
            tooltips: [],
            age_list: [],
            area_list: [],
            sex_list: [],
            member_count: 0,
            is_member_page: true,
            is_member_load_under: false,
            member_page: 1,
            first_view: true,
            tweet: "",
            CARD_REGISTRATION_STATE,
        };
    },
    mounted: function () {
        window.addEventListener("scroll", this.handleScroll)
    },
    methods: {
        isUnauthorizedError(error) {
            return error && error.response && error.response.status == 401
        },
        async regCardMember() {
            if (this.user.card_limit_count > 0) {
                await axios.get("/api/card/member/reg/" + this.$route.params['cid'])
                    .then(
                        (response) => {
                            const isOwner = Number(this.card.user_id) === Number(this.user.id)
                            this.btn_type = isOwner ? CARD_REGISTRATION_STATE.OWNER_REGISTERED : CARD_REGISTRATION_STATE.MEMBER_REGISTERED
                            this.user.card_limit_count = response.data.limit_count
                        }
                    )
                    .catch((error) => {
                        if (this.isUnauthorizedError(error)) {
                            window.location.href = "/auth?logout=true"
                        }
                        else {
                            this.$showErrorToast("カードの登録に失敗しました")
                        }
                    })
            }
            else {
                if (this.user.is_limited) {
                    alert('11枚以上の登録は有料機能です。多くの登録をすることで、マッチング率が10倍になります。')
                }
                else {
                    alert('登録最大上限に達しました。新しく登録する場合は既に選んでるカードを外してください。')
                }
                return
            }
        },
        async rmCardMember() {
            await axios.get("/api/card/member/rm/" + this.$route.params['cid'])
                .then(
                    (response) => {
                        const isOwner = Number(this.card.user_id) === Number(this.user.id)
                        this.btn_type = isOwner ? CARD_REGISTRATION_STATE.OWNER_REGISTERABLE : CARD_REGISTRATION_STATE.MEMBER_REGISTERABLE
                        this.user.card_limit_count = response.data.limit_count
                    }
                )
                .catch((error) => {
                    if (this.isUnauthorizedError(error)) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast("カードの登録解除に失敗しました")
                    }
                })
        },
        async init() {
            await axios.get("/api/auth/user/get")
                .then(
                    () => {
                        this.fetchUsers()
                    }
                )
                .catch((error) => {
                    if (this.isUnauthorizedError(error)) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast("ユーザーの取得に失敗しました")
                    }
                })
        },
        async fetchUsers() {
            await axios.get("/api/user/get/me")
                .then((response) => {
                    this.user = response.data.user
                })
                .catch((error) => {
                    if (this.isUnauthorizedError(error)) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast("ユーザーの取得に失敗しました")
                    }
                })
        },
        async fetchMember() {
            await axios.get("/api/card/member/list/" + this.$route.params['cid'])
                .then((response) => {
                    this.members = response.data.card_member.data
                    this.member_count = response.data.member_count

                    if (this.member_count <= 20) {
                        this.is_member_page = false
                    }
                })
                .catch((error) => {
                    if (this.isUnauthorizedError(error)) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast("登録中のメンバーの取得に失敗しました")
                    }
                })
        },
        async fetchMemberMore() {
            this.is_member_load_under = true
            this.member_page++

            await axios.get("/api/card/member/list/" + this.$route.params['cid'] + "?page=" + this.member_page)
                .then((response) => {
                    this.members.push.apply(this.members, response.data.card_member.data)

                    if (response.data.card_member.data.length == 0) {
                        this.is_member_page = false
                    }
                })
                .catch((error) => {
                    if (this.isUnauthorizedError(error)) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast("登録中のメンバーの取得に失敗しました")
                    }
                }).finally(() => {
                    this.is_member_load_under = false
                })
        },
        async fetchCard() {
            await axios.get("/api/card/get/" + this.$route.params['cid'])
                .then((response) => {
                    const card = response.data.card
                    if (!card) {
                        // card が取得できないまま getMessage(this.card.id) を呼ぶと
                        // TypeError が同じ .catch に吸われ、通信エラーとして握り潰されるため
                        // ここで明示的に打ち切る
                        this.$showErrorToast("カードの取得に失敗しました")
                        return
                    }

                    this.card = card
                    this.btn_type = response.data.btn_type
                    this.tweet = response.data.tweet

                    this.getMessage(card.id)
                })
                .catch((error) => {
                    if (this.isUnauthorizedError(error)) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast("カードの取得に失敗しました")
                    }
                })
        },
        async getMessage(cid) {
            await axios.get("/api/card/message/get/" + cid)
                .then((response) => {
                    this.user_list = response.data.messages.data
                    this.count = response.data.count

                    if (this.count != 0) {
                        this.first_view = false
                    }

                    let c = []
                    this.user_list.forEach(function (message) {
                        c[message.id] = false
                    })

                    this.tooltips = c

                    if (this.count <= 20) {
                        this.is_page = false
                    }

                    this.getEmoji(this.card.id)
                })
                .catch((error) => {
                    if (this.isUnauthorizedError(error)) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast("コメントの取得に失敗しました")
                    }
                })
        },
        async getMessageMore() {
            this.is_load_under = true
            this.page++

            await axios.get("/api/card/message/get/" + this.card.id + "?page=" + this.page)
                .then((response) => {
                    this.user_list.push.apply(this.user_list, response.data.messages.data)

                    let c = this.tooltips
                    response.data.messages.data.forEach(function (message) {
                        c[message.id] = false
                    })

                    this.tooltips = c

                    if (response.data.messages.data.length == 0) {
                        this.is_page = false
                    }
                    this.getEmoji(this.card.id)

                    if (response.data.messages.data.length == 0) {
                        this.is_page = false
                    }
                })
                .catch((error) => {
                    if (this.isUnauthorizedError(error)) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast("コメントの取得に失敗しました")
                    }
                }).finally(() => {
                    this.is_load_under = false
                })
        },
        async getEmoji(cid) {
            await axios.get("/api/card/emoji/get/" + cid)
                .then((response) => {
                    let list = this.emojis
                    let keys = Object.keys(list)

                    response.data.emojis.forEach(function (e) {
                        keys = Object.keys(list)
                        var key = keys.find(function (value) {
                            return value == e.card_message_id
                        })

                        if (key === void 0) {
                            list[e.card_message_id] = []
                        }

                        list[e.card_message_id].push({
                            "id": e.id,
                            "emoji": e.emoji,
                            "count": e.count
                        })
                    })

                    this.emojis = list
                })
                .catch((error) => {
                    if (this.isUnauthorizedError(error)) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast("絵文字の取得に失敗しました")
                    }
                })
        },
        async setMessage() {
            await axios.post("/api/card/message/set", {
                message: this.message,
                card_id: this.card.id,
            })
                .then((response) => {
                    this.message = ""
                    this.getMessage(this.card.id)
                })
                .catch((error) => {
                    if (this.isUnauthorizedError(error)) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast("メッセージの送信に失敗しました")
                    }
                })
        },
        async handleEmojiClick(e, emoji, i, c, id) {
            e.preventDefault();
            this.$emit('emoji_click', emoji);

            await axios.post("/api/card/emoji/set", {
                card_message_id: this.cmid,
                emoji: emoji,
                card_id: this.card.id,
                category: c,
                emoji_no: i,
                emoji_id: "",
            })
                .then((response) => {
                    this.user_list[this.message_index].emojis = response.data.emojis

                    this.tooltipEmojis(id, 'tooltipEmojiRef' + id, 'tooltipEmojiPickerRef' + id)
                })
                .catch(function (error) {
                })
        },
        async addEmoji(emoji, emoji_id, card_message_id, card_id, message_index, emoji_index) {
            await axios.post("/api/card/emoji/set", {
                card_message_id: card_message_id,
                emoji: emoji,
                card_id: this.card.id,
                category: "",
                emoji_no: "",
                emoji_id: emoji_id,
            })
                .then((response) => {
                    this.user_list[message_index].emojis[emoji_index].count = response.data.count
                    this.showTooltip = false

                    if (response.data.count == 0) {
                        this.user_list[message_index].emojis.splice(emoji_index)
                    }
                })
                .catch(function (error) {
                })
        },
        tooltipEmojis(n, e, p) {
            var re = this.$refs[e][0]
            var pi = this.$refs[p][0]

            if (this.tooltips[n]) {
                re.style.height = '0rem'
                pi.style.padding = '0rem'
                re.style.border = '0px'
            }
            else {
                const rect = re.getBoundingClientRect()
                if (window.innerWidth < rect.right) {
                    re.style.right = '20px'
                }
                pi.style.padding = '1rem'
                re.style.height = '20rem'
                re.style.border = '1px solid #ddd'

            }
            this.tooltips[n] = !this.tooltips[n]
        },
        async handleScroll() {
            let bottom = document.body.scrollHeight - document.body.clientHeight

            this.scrollY = window.scrollY
            let p = Math.abs(bottom - this.scrollY)
            if (this.tab == 1) {
                if (p < 1 && this.is_page) {
                    this.getMessageMore()
                }
            }
            else {
                if (p < 1 && this.is_member_page) {
                    this.fetchMemberMore()
                }
            }
        },
        async setPenalty(status, id) {
            await axios.post("/api/card/penalty/set", {
                id: id,
                status: status
            })
                .then((response) => {
                    alert("通報しました。");
                })
                .catch((error) => {
                    if (this.isUnauthorizedError(error)) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast("通報に失敗しました")
                    }
                })
        },
        setTweets(msg) {
            window.open(this.tweet + msg.substring(0, 49) + '%0a&hashtags=LunaSM')
        },
        nextShowUser(uid) {
            clearPageStorage()
            window.location.href = "/user/show/" + uid + "?profile_source=card_detail"
        },
        confirmSave() {
            clearPageStorage()
        },
        async rmMessage(cid) {
            await axios.get("/api/card/message/rm/" + cid)
                .then(
                    (response) => {
                        this.getMessage(this.$route.params['cid'])
                    }
                )
                .catch((error) => {
                    if (this.isUnauthorizedError(error)) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast("メッセージの削除に失敗しました")
                    }
                })
        },
        linkDetail(cmid) {
            window.location.href = "/card/message/detail/" + cmid
        }
    },
    async created() {

        // 自動ログインチェック
        var arr = new Array();
        if (document.cookie != '') {
            var tmp = document.cookie.split('; ');
            for (var i = 0; i < tmp.length; i++) {
                var data = tmp[i].split('=');
                arr[data[0]] = decodeURIComponent(data[1]);
            }

            if (arr['uid'] != undefined) {
                await axios.get("/api/user/auth/" + arr['uid'])
                    .then(
                        (response) => {
                            localStorage.setItem('prev_type', 2)
                            localStorage.setItem('prev_page', this.$route.path)

                            localStorage.setItem('redirect', this.$route.path)

                            this.windowSize = window.innerWidth
                            this.init()
                            this.fetchCard()
                            this.fetchMember()
                        })
                    .catch((error) => {
                        this.$showErrorToast("ユーザーの取得に失敗しました")
                    })
            }
            else {
                localStorage.setItem('prev_type', 2)
                localStorage.setItem('prev_page', this.$route.path)

                localStorage.setItem('redirect', this.$route.path)

                this.windowSize = window.innerWidth
                this.init()
                this.fetchCard()
                this.fetchMember()
            }
        }
        else {
            localStorage.setItem('prev_type', 2)
            localStorage.setItem('prev_page', this.$route.path)

            localStorage.setItem('redirect', this.$route.path)

            this.windowSize = window.innerWidth
            this.init()
            this.fetchCard()
            this.fetchMember()
        }
    },
    props:
    {
        show_arrow:
        {
            type: Boolean,
            required: false,
            default: true
        }
    },
    computed:
    {
        categories() {
            return Object.keys(EmojiData);
        },
        category_emojis: () => (category) => {
            return Object.values(EmojiData[category]);
        }
    },
    filters: {
        loginStatus(login_at) {
            let status = "数秒前"

            let dt = new Date()
            let lg = new Date(login_at)

            lg.setHours(lg.getHours() + 9)

            var diff = dt.getTime() - lg.getTime()
            //分
            var minutes = Math.floor(diff / (60 * 1000))
            //時
            var hour = Math.floor(diff / (60 * 60 * 1000))
            //日
            var day = Math.floor(diff / (1000 * 60 * 60 * 24))

            if (day == 0 && hour == 0 && minutes > 0) {
                status = minutes + "分前"
            } else if (day == 0 && hour > 0) {
                status = hour + "時間前"
            } else if (day > 0 && day < 31) {
                status = day + "日前"
            } else if (day > 30) {
                status = "30日以上前"
            }

            return status
        },
        lastLoginStatus(login_at) {
            let status = "数秒前"

            let dt = new Date()
            let lg = new Date(login_at)

            //lg.setHours(lg.getHours() + 9)

            var diff = dt.getTime() - lg.getTime()
            //分
            var minutes = Math.floor(diff / (60 * 1000))
            //時
            var hour = Math.floor(diff / (60 * 60 * 1000))
            //日
            var day = Math.floor(diff / (1000 * 60 * 60 * 24))

            if (day == 0 && hour == 0 && minutes > 0) {
                status = minutes + "分前"
            } else if (day == 0 && hour > 0) {
                status = hour + "時間前"
            } else if (day > 0 && day < 31) {
                status = day + "日前"
            } else if (day > 30) {
                status = "30日以上前"
            }

            return status
        },
        omittedText(text) {
            if (text == null) {
                return ""
            } else {
                return text.length > 50 ? text.slice(0, 50) + "…" : text
            }
        },
    },
};
</script>
<style scoped>
.luna-footer-card-menu {
    position: fixed;
    bottom: 0;
    width: 538px;
    min-height: 80px;
    background-color: #ffffff86;
    padding: 12px 0 20px;
    z-index: 99999;
}

.luna-header-box {
    box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.1);
    height: 56px;
    width: 540px;
    background-color: #fff;
    z-index: 999;
}

@media (max-width: 576px) {
    .luna-header-box {
        width: 100%;
    }

    .luna-footer-card-menu {
        width: 100%;
    }
}

.emoji_picker {
    position: relative;
    display: flex;
    flex-direction: column;
    width: 20rem;
    height: 20rem;
    max-width: 100%;
}

.picker_container {
    border-radius: 0.5rem;
    background: white;
}

.picker_container {
    position: relative;
    overflow: auto;
    z-index: 1;
}

.category {
    display: flex;
    flex-direction: column;
    margin-bottom: 1rem;
    color: rgb(169, 169, 169);
}

.emojis_container {
    display: flex;
    flex-wrap: wrap;
}

.category button {
    margin: 0.5rem;
    margin-left: 0;
    background: inherit;
    border: none;
    font-size: 1rem;
    padding: 0;
}

.picker_box {
    width: 20rem;
    height: 0rem;
    border: 0px;
    z-index: 9999;
    position: absolute;
    background-color: #fff;
    margin-top: -20rem;
    border-radius: 5px;
}

.dropdown {
    position: relative;
    display: inline-block;
}

.dropdown-content {
    display: none;
    position: absolute;
    background-color: #f9f9f9;
    min-width: 80px;
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
    padding: 12px 16px;
    z-index: 1;
    right: 0;
}

.dropdown:hover .dropdown-content {
    display: block;
}

.luna-card-active {
    border-bottom: 2px solid #6B4EFF;
    color: #6B4EFF;
    font-size: 14px;
}

.luna-card-non-active {
    border-bottom: 1px solid #CDCDCD;
    color: #CDCDCD;
    font-size: 14px;
}
</style>
